import api from "./axios";
export const getStoreProfile = () => api.get("/store-profile");
export const updateStoreProfile = (payload) => api.put("/store-profile", payload);
